module.exports = __webpack_public_path__ + "img/cut.21a74bf7.png";